var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgWavyUnderlineFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 8,
    viewBox: "0 0 218 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 225",
    d: "M1 1.5L14.5 4.5C23.3916 6.4759 32.6084 6.4759 41.5 4.5V4.5C50.3916 2.5241 59.6084 2.5241 68.5 4.50001V4.50001C77.3915 6.47591 86.6084 6.47591 95.5 4.50001V4.50001C104.392 2.52411 113.608 2.52411 122.5 4.50001V4.50001C131.392 6.47591 140.608 6.47591 149.5 4.50001V4.50001C158.392 2.52411 167.608 2.52411 176.5 4.50002V4.50002C185.392 6.47592 194.608 6.47592 203.5 4.50002L217 1.50002",
    stroke: "#3AB078",
    strokeWidth: 2.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyUnderlineFilled);
export default __webpack_public_path__ + "static/media/wavyUnderlineFilled.5d67239ee0041c19bd95e8828b662b98.svg";
export { ForwardRef as ReactComponent };